import { Component, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import { Constant } from '../../../environments/constants';
import { Subscription } from 'rxjs';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import * as fromModel from '../../services/models';
import * as Highcharts from 'highcharts';
import addMore from "highcharts/highcharts-more";
import { Utils } from '../../../utils/utils';
import { RefDataService } from '../../services/context/ref-data.service';
//addMore(Highcharts)

@Component({
  selector: 'gp-income',
  templateUrl: './income.component.html',
  styleUrls: ['./income.component.scss']
})
export class IncomeComponent implements OnInit, OnDestroy {

  protected _storeDataSubscription: Subscription;
  protected _uiStateSubscription: Subscription;

  Highcharts: typeof Highcharts = Highcharts;
  options: Highcharts.Options;
  private chart: Highcharts.Chart;

  goalSummary;
  
  isDataAvailable = false;
  yoyCashFlows;
  appliedPlan: fromModel.Plan;
  
  constructor(private dataService: DataService,
      private uiStateService: UIStateService,  
      private refDataService: RefDataService,
      private appMonitoringService: AppMonitoringService) {    
  }

  ngOnInit(): void {
    //this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "IncomeComponent-ngOnInit", true);
    this.dataService.getPlanAnalysis();    
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   
    this._uiStateSubscription =  this.uiStateService.subscribe((uiState: fromModel.IUIState) => this.populateUIContext(uiState));     
  }

  private populateAppData(appData: fromModel.IAppData){    
      this.yoyCashFlows = null;
      this.isDataAvailable = false;
      if(appData && (appData.action===fromModel.DATA_ACTION.UPDATESETTINGS)){                
        this.dataService.getGoalSummary();
        this.dataService.getPlanAnalysis();      
      } else {
      if(appData && appData.action!==fromModel.DATA_ACTION.NONE){      
        let yoyCFs = this.dataService.getPlanAnalysisyoyCashFlows();
        let appPlan = this.dataService.getAppliedPlan();
        if(yoyCFs!== null && appPlan!=null){
          if(yoyCFs.Error || appPlan.Error){
            this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG, "IncomeComponent-populateAppData - Error", {ShowMsg: true,  MsgType: fromModel.MSGTYPE.ERROR, Msg: Constant.ErrorMsgs.analyticErrorMsg});
          } else {
            this.yoyCashFlows =  yoyCFs;
            this.appliedPlan = appPlan;
            this.setChartOptionsData();
            this.isDataAvailable = true;
            this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "IncomeComponent-populateAppData", false);
          }
        }
      }
    }
  }

  populateUIContext(uiState: fromModel.IUIState){     
    if(uiState && uiState.action === fromModel.UI_STATE_ACTION.REFRESH){
      if(uiState.Refresh){
        this.resizeChart();
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.REFRESH, "IncomeComponent-populateUIContext", false);        
      }
      
    }
  }

  private setChartOptionsData(){
    this.options = {
      chart: {
        type: 'column',
        style: {
          fontSize: '18'
        } 
      },
      title: {
          text: ''
      },
      subtitle: {
        text: ''
      },
      credits: {
        enabled: false
      },
      xAxis: {
        title: {              
          text: '',
          style: {
            fontSize: '16'
          }
        },
        labels: {
          style: {            
              fontSize:'14'
          }
        },
        type: 'datetime',
        startOnTick: true,
        tickInterval: 1000 * 60 * 60 * 24 * 1825,  
        //tickWidth: 0,
        //visible: true,
        //endOnTick: true,
        //showLastLabel: false,
        // labels: {
        //   enabled: false,
        //   style: {                
        //     fontSize: '16'
        //   }
        // },
        //showFirstLabel: true,            
        //tickWidth: 0,
        // tickInterval: 12,
        //allowDecimals: false,
        //min: 0      
      },
      yAxis: {
        title: {
            text: 'Income ($)',
            style: {
              fontSize: '16'
            }
        },          
        labels: {
          style: {                
              fontSize: '16'
          }
        },
        lineWidth: 0,
        //tickInterval: 2,
        allowDecimals: false,
        //min: 0          
      },
      legend: {
        enabled: true, 
        itemStyle:{
          fontSize: '14'
        }      
      },
      tooltip: {
        shared:true,
        useHTML: true,
        // headerFormat: '<small>{point.key}</small><table>',
        // pointFormat: '<tr><td style="color: {series.color}">{series.name}: </td>' +
        // '<td style="text-align: right"><b>$ ' + Highcharts.numberFormat(Number(500),0,'.',',') + '</b></td></tr>',
        // footerFormat: '</table>',
        style:{
          color: '#4F528C', 
          fontSize: '14',
          fontFamily: 'Avenir',
          fontWeight: 'bold'
        },
        formatter: function(){
          //console.log(this.points);
          var formatStr = "";          
          if(this.points && this.points.length>0){
            formatStr += '<div class="font16">' + Highcharts.dateFormat('%Y',this.points[0].x) + '</div>';
            var ageSeries = this.points.find(point=>point.series.name === fromModel.CHARTSERIESNAME.Age);
            if(ageSeries){
              var data = ageSeries.series.data.find(data=>data.x === ageSeries.x);
              if(data){
                formatStr += '<span class="font14 pClient">' + data['pName'] + ': <span class="font12">age</span> ' + data['pAge'] + '</span>'; 
                if(data['sDisplayName']){
                  formatStr += ' | <span class="font14 sClient">' + data['sName'] + ': <span class="font12">age</span> ' + data['sAge'] + '</span>'; 
                } 
                formatStr += '</br></br>';              
              }
            }                      
            formatStr +=  '<table style="width: 100%">';
            for (var i = 0; i < this.points.length; i++) {
              var point = this.points[i];
              if(point.series.name!==fromModel.CHARTSERIESNAME.TotalExpense 
                && point.series.name!==fromModel.CHARTSERIESNAME.EssentialExpense
                && point.series.name!==fromModel.CHARTSERIESNAME.IncomeTaxes
                && point.series.name!==fromModel.CHARTSERIESNAME.Age){        
                  formatStr += '<tr>';
                  formatStr += '<td style="color:'  + point.color + '">' + point.series.name + '</td>';
                  formatStr += '<td style="text-align: right; padding-left:50px"><b> $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b></td>'; 
                  formatStr += '</tr>';
              }
            }
            formatStr += '</table>';
            formatStr +=  '<hr>';
            formatStr +=  '<table style="width: 100%">';
            for (var i = 0; i < this.points.length; i++) {
              var point = this.points[i];
              if(point.series.name===fromModel.CHARTSERIESNAME.TotalExpense 
                || point.series.name===fromModel.CHARTSERIESNAME.EssentialExpense
                || point.series.name===fromModel.CHARTSERIESNAME.IncomeTaxes
                ){        
                  formatStr += '<tr>';
                  formatStr += '<td style="color:'  + point.color + '">' + point.series.name + '</td>';
                  formatStr += '<td style="text-align: right; padding-left:50px"><b> $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b></td>'; 
                  formatStr += '</tr>';
              }
            }
            formatStr += '</table>';        
          }
          return formatStr;
        },
      },
      plotOptions: {
          column: {
              stacking: 'normal',
              dataLabels: {
                  enabled: false
              }
          },
          series: {
            stacking: 'normal',
            stickyTracking: false,
            states: {
                inactive: {
                    opacity: 1
                }
            }
        }        
      },
      series: []
    }; 
    let { series } = this.options;
    series = this.getChartData(series);
    this.options = {...this.options, series};   
  }

  private getChartData(series){
    let data = [];
    let displayDate;
    let inc;
    let _d;
    let totalExpenseData = [];
    let essentialExpense = [];
    let totalTaxesData = [];
    let pRMDData = [];
    let sRMDData = [];
    let returnSeries = [];
    let seriesColor;

    if(this.appliedPlan && this.appliedPlan.incomes && this.appliedPlan.incomes.length>0){
      this.appliedPlan.incomes.forEach(_inc => {
        data = [];  
        totalExpenseData = []; 
        essentialExpense = []; 
        totalTaxesData = [];
        pRMDData = [];
        sRMDData = [];
        let cNameAge;
        let incDesc;
        let cRole;

        if(this.yoyCashFlows && this.yoyCashFlows.length>0){
          this.yoyCashFlows.forEach(cashFlow => {            
            
            displayDate = Date.UTC(Number(cashFlow.yr), 0, 1);
            cNameAge = this.dataService.getClientNameAge(cashFlow.yr);

            if(cashFlow.c1Rmd && cashFlow.c1Rmd>0){
              pRMDData.push({x: displayDate, y: cashFlow.c1Rmd, incId: '', incType: 'RMD', incDesc: `RMD ${cNameAge.pName}`});
            }

            if(this.dataService.isSecondaryClient()){
              //totalExpenseData.push({x: displayDate , y:cashFlow.totExpense, pName: cNameAge.pName, pAge: cNameAge.pAge, sName: cNameAge.sName, sAge: cNameAge.sAge});  
              totalExpenseData.push({x: displayDate , y:cashFlow.totExpense-cashFlow.essentialExpense, pName: cNameAge.pName, pAge: cNameAge.pAge, sName: cNameAge.sName, sAge: cNameAge.sAge});  
              essentialExpense.push({x: displayDate , y:cashFlow.essentialExpense, pName: cNameAge.pName, pAge: cNameAge.pAge, sName: cNameAge.sName, sAge: cNameAge.sAge});  
              totalTaxesData.push({x: displayDate , y:cashFlow.totTax, pName: cNameAge.pName, pAge: cNameAge.pAge, sName: cNameAge.sName, sAge: cNameAge.sAge});  
              if(cashFlow.c2Rmd && cashFlow.c2Rmd>0){
                sRMDData.push({x: displayDate, y: cashFlow.c2Rmd, incId: '', incType: 'RMD', incDesc: `RMD ${cNameAge.sName}`});
              }
            } else {
              //totalExpenseData.push({x: displayDate , y:cashFlow.totExpense, pName: cNameAge.pName, pAge: cNameAge.pAge});  
              totalExpenseData.push({x: displayDate , y:cashFlow.totExpense-cashFlow.essentialExpense, pName: cNameAge.pName, pAge: cNameAge.pAge});  
              essentialExpense.push({x: displayDate , y:cashFlow.essentialExpense, pName: cNameAge.pName, pAge: cNameAge.pAge});                
              totalTaxesData.push({x: displayDate , y:cashFlow.totTax, pName: cNameAge.pName, pAge: cNameAge.pAge});  
            }
            if(cashFlow && cashFlow.totIncomeIds && cashFlow.totIncomeIds.length>0){
                inc = cashFlow.totIncomeIds.find(incCodeValue=>incCodeValue.code === _inc.incId);
                if(inc){
                
                   
                  if(_inc.owner){
                    incDesc = `${_inc.incDesc} (${this.dataService.getPlanClientByClientId(_inc.owner).clientname})`;       
                    cRole = this.dataService.getPlanClientByClientId(_inc.owner).role;
                  } else {
                    incDesc = 'Joint';
                    cRole = fromModel.CLIENTROLE.Joint;
                  }
                  _d = {x: displayDate, y: inc.value, incId: inc.code, incType: _inc.incType, incDesc: incDesc};
                  data.push(_d);   
                }
            }           
          });
        }
        
        if(_inc.owner){
           incDesc = `${_inc.incDesc} (${this.dataService.getPlanClientByClientId(_inc.owner).clientname})`;       
           cRole = this.dataService.getPlanClientByClientId(_inc.owner).role;
        } else {
          incDesc = 'Joint';
          cRole = fromModel.CLIENTROLE.Joint;
        }

        if(cRole === fromModel.CLIENTROLE.Primary){
          seriesColor = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.PrimaryIncomeColors, _inc.incType).value;
        } else if(cRole === fromModel.CLIENTROLE.Secondary){
          seriesColor = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.SecondaryIncomeColors, _inc.incType).value;
        } else if(cRole === fromModel.CLIENTROLE.Joint){
          seriesColor = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.JointIncomeColors, _inc.incType).value;
        }
        
        series.push({name: incDesc, role: cRole, incType: _inc.incType, type: 'column', data: data, color: seriesColor});        
      });

      //RMD series for Primary Client
      if(pRMDData && pRMDData.length>0){
        
        
        seriesColor = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.PrimaryIncomeColors, 'RMD').value;
        series.push({name: `RMD (${this.dataService.getClientByRole(fromModel.CLIENTROLE.Primary).clientname})`, role: fromModel.CLIENTROLE.Primary, incType: 'RMD', type: 'column', data: pRMDData, color: seriesColor});        
      }

      //RMD series for Secoundary Client
      if(sRMDData && sRMDData.length>0){
        seriesColor = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.SecondaryIncomeColors, 'RMD').value;
        series.push({name: `RMD (${this.dataService.getClientByRole(fromModel.CLIENTROLE.Secondary).clientname})`, role: fromModel.CLIENTROLE.Secondary, incType: 'RMD', type: 'column', data: sRMDData, color: seriesColor});        
      }
      

      /*********Start: Sorting Logic*******/

      let seriesSortedByClient = [];
      let ser;

      //get all secoundary client row
      ser = series.filter(_s=>_s.role === fromModel.CLIENTROLE.Secondary);
      if(ser && ser.length>0){
        ser.forEach(_s => {
          seriesSortedByClient.push(_s);  
        });
      }

      //get all primary client row     
      ser = series.filter(_s=>_s.role === fromModel.CLIENTROLE.Primary);
      if(ser && ser.length>0){
        ser.forEach(_s => {
          seriesSortedByClient.push(_s);  
        });
      }

      //get all joint client row
      ser = series.filter(_s=>_s.role === fromModel.CLIENTROLE.Joint);
      if(ser && ser.length>0){
        ser.forEach(_s => {
          seriesSortedByClient.push(_s);  
        });
      }

      //sort based on income types
      let incomeChartRef = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.IncomeChart);
      incomeChartRef.forEach(incRef => {
        ser = seriesSortedByClient.filter(_s=>_s.incType === incRef.code);
        if(ser && ser.length>0){
          ser.forEach(_s => {
            returnSeries.push(_s);  
          });
        }
      });
      /*********End: Sorting Logic*******/

      returnSeries.push({name: fromModel.CHARTSERIESNAME.TotalExpense, dType: 'exp', type: 'spline', data: totalExpenseData, lineWidth: 2, dashStyle: 'ShortDash', color: '#4F528C', marker: {enabled: false}});
      returnSeries.push({name: fromModel.CHARTSERIESNAME.EssentialExpense, dType: 'essexp', type: 'spline', data: essentialExpense, lineWidth: 2, color: '#4F528C', marker: {enabled: false}});
      returnSeries.push({name: fromModel.CHARTSERIESNAME.IncomeTaxes, dType: 'inctaxes', type: 'spline', data: totalTaxesData, lineWidth: 2, color: '#f29305', marker: {enabled: false}});
      

      // series.push({name: 'Expense', type: 'spline', data: totalExpenseData, lineWidth: 2, color: '#4F528C', marker: {enabled: false}});
      // series.push({name: 'Essential Expense', type: 'spline', data: essentialExpense, lineWidth: 2, dashStyle: 'ShortDash', color: '#F24405 4F528C', marker: {enabled: false}});
    }

    //console.log(JSON.stringify(this.dataService.getChartSeries({chartSeriesType: fromModel.CHARTSERIESTYPE.AGE})));
    
    returnSeries.push(this.dataService.getChartSeries({chartSeriesType: fromModel.CHARTSERIESTYPE.AGE}).series[0]);
    //returnSeries.push(this.dataService.getChartSeries({chartSeriesType: fromModel.CHARTSERIESTYPE.BALANCEBYTAXSTATUS}).series[1]);
    //console.log(JSON.stringify(returnSeries));
    return returnSeries;
  }

  @HostListener('window:resize', ['$event'])
  onResize(){
    if(this.chart) {
      this.chart.reflow();
    }
  }

  resizeChart(){
    setTimeout(() => {
      if(this.chart && this.chart.hasOwnProperty('series')) {
        this.chart.reflow();
      }
    }, 200);
  }

  public chartCallBack = (chart: Highcharts.Chart) => {
    this.chart =  chart;
    setTimeout(() => {
      if(this.chart && this.chart.hasOwnProperty('series')) {
        this.chart.reflow();
      }
    }, 100);
  }

  ngOnDestroy(): void{
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }
    if(this._uiStateSubscription && this._uiStateSubscription !== null){
      this._uiStateSubscription.unsubscribe();    
    }    
  }
}



// formatter: function(){
//   var formatStr = "";

//   // for (var i = 0; i < this.points.length; i++) {
//   //   var point = this.points[i];
//   //   if(point.series.name==='Expense'){
//   //     formatStr += point['pName'] + ': ' + point['pAge'] + " years <br/>";
//   //     if(point['sName'] && point['sAge']){
//   //       formatStr += point['sName'] + ': ' + point['sAge'] + " years <br/>";
//   //     }
//   //   }
//   // }

//   // for (var i = 0; i < this.points.length; i++) {
//   //   var point = this.points[i];
//   //   if(i===0)
//   //   {
//   //     formatStr += "<b>" + Highcharts.dateFormat('%Y',point.x) + "</b><br/>";
//   //   }
//   //   if(point.series.name!=='Range'){        
//   //     formatStr += '<span style="color:' + point.color + '">●</span> ' + point.series.name + '<b>: $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b><br/>';
//   //   }
//   // }

//   // for (var i = 0; i < this.points.length; i++) {
//   //   var point = this.points[i];
//   //   if(point.series.name==='Expense'){        
//   //     formatStr += '<span style="color:' + point.color + '">●</span> ' + point.series.name + '<b>: $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b><br/>';
//   //   }
//   // }

//   for (var i = 0; i < this.points.length; i++) {
//     var point = this.points[i];
//     if(i===0)
//     {
//       formatStr += '<small>' + Highcharts.dateFormat('%Y',point.x) + '</small>';
//     }
//     //if(point.series['dType']!=='essexp' && point.series['dType']!=='exp'){        
//     if(point.series.name!=='Total Expense' && point.series.name!=='Essential Expense'){        
//       //formatStr += '<span style="color:' + point.color + '">●</span> ' + point.series.name + '<b>: $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b><br/>';
//       formatStr +=  '<table style="width: 100%"><tr><td style="color:'  + point.color + '">' + point.series.name + '</td>' + '<td style="text-align: right; padding-left:50px"><b> $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b></td></tr></table>';
//     }
//   }


//   for (var i = 0; i < this.points.length; i++) {
//     var point = this.points[i];
//     //if(point.series['dType']!=='essexp' && point.series['dType']!=='exp'){        
//     if(point.series.name==='Essential Expense'){        
//       //formatStr += '<span style="color:' + point.color + '">●</span> ' + point.series.name + '<b>: $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b><br/>';
//       formatStr +=  '<table style="width: 100%"><tr style="border-top: 2px solid gray"><td style="color:'  + point.color + '">' + point.series.name + '</td>' + '<td style="text-align: right; padding-left:50px"><b> $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b></td></tr></table>';
//     }
//   }

//   for (var i = 0; i < this.points.length; i++) {
//     var point = this.points[i];
//     //if(point.series['dType']!=='essexp' && point.series['dType']!=='exp'){        
//     if(point.series.name==='Total Expense'){        
//       //formatStr += '<span style="color:' + point.color + '">●</span> ' + point.series.name + '<b>: $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b><br/>';
//       formatStr +=  '<table style="width: 100%"><tr><td style="color:'  + point.color + '">' + point.series.name + '</td>' + '<td style="text-align: right; padding-left:50px"><b> $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b></td></tr></table>';
//     }
//   }



//   return formatStr;
// }